/**
 * Auth screen hero: kiwi mascot with radial glow, orbiting content icons,
 * and brand text. Shared by SignInPage and SignUpPage.
 */

import { KiwiSkinRenderer } from "@/components/brand/KiwiSkinRenderer";
import { PALETTES } from "@/components/brand/kiwiPalettes";
import type { KiwiSkinConfig } from "@/types/kiwiSkin";
import { ContentOrbitView } from "@/components/auth/ContentOrbitView";

const DEFAULT_KIWI: KiwiSkinConfig = {
  name: "Forest Walker",
  variant: "knight",
  palette: "forest",
  environment: "none",
  artifact: "none",
  effect: "none",
  rarity: "Common",
};

const GLOW_COLOR = PALETTES.forest.body;

export function AuthHeroSection() {
  return (
    <div className="mb-6 flex flex-col items-center">
      {/* Kiwi mascot with glow + orbit */}
      <div className="relative mb-4 h-[220px] w-[220px] animate-[fadeScale_0.6s_ease-out_both]">
        {/* Blurred backdrop circle */}
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full blur-[20px]"
          style={{
            width: 200,
            height: 200,
            background: "var(--background)",
            opacity: 0.85,
          }}
        />

        {/* Radial glow */}
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{
            width: 220,
            height: 220,
            background: `radial-gradient(circle, ${GLOW_COLOR}40 0%, ${GLOW_COLOR}1a 50%, transparent 70%)`,
          }}
        />

        {/* Orbiting icons */}
        <ContentOrbitView radius={80} color={GLOW_COLOR} />

        {/* Kiwi */}
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
          style={{
            filter: `drop-shadow(0 4px 16px ${GLOW_COLOR}66)`,
          }}
        >
          <div className="h-[80px] w-[80px]">
            <KiwiSkinRenderer config={DEFAULT_KIWI} />
          </div>
        </div>
      </div>

    </div>
  );
}
